import classNames from 'classnames';
import { useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { MembershipPeriod, MembershipPlan } from '../MemebershipPlans';
import styles from './PlansItem.module.scss';

interface PlansItemProps {
    planKey: MembershipPeriod;
    plan: MembershipPlan;
    setSelectedPlan: (plan: MembershipPeriod) => void;
    isSelected: boolean;
}

const PlansItem = ({ planKey, plan, setSelectedPlan, isSelected }: PlansItemProps) => {
    const { t } = useTranslation();
    const cardRef = useRef<HTMLDivElement>(null);

    useEffect(() => {
        if (isSelected && cardRef.current) {
            cardRef.current.classList.add(styles.zoomAnimation);
            // Remove the animation class after it completes to allow it to run again if needed
            const timeout = setTimeout(() => {
                cardRef.current?.classList.remove(styles.zoomAnimation);
            }, 2000); // 2 seconds = duration of the animation

            return () => clearTimeout(timeout);
        }
    }, [isSelected]);

    return (
        <div
            ref={cardRef}
            className={classNames(styles.planCard, {
                [styles.selected]: isSelected
            })}
            onClick={() => setSelectedPlan(planKey)}
        >
            <div className={styles.planHeader}>
                <h2>{t(plan.Title)}</h2>
                <span className={styles.price}>{plan.FormattedPrice}</span>
            </div>
            {planKey === MembershipPeriod.Yearly && (
                <div className={styles.popularTag}>
                    {t('POPULAR')}
                </div>
            )}
            {planKey === MembershipPeriod.Lifetime && (
                <div className={styles.note}>
                    {t('commit once to reach English mastery')}
                </div>
            )}
            {planKey === MembershipPeriod.Basic && (
                <div className={styles.note}>
                    {t("Don't even try Pro (not recommended)")}
                </div>
            )}
        </div>
    );
};

export default PlansItem;
